import { render, staticRenderFns } from "./ModalHistoryAttachment.vue?vue&type=template&id=63814f91&scoped=true"
import script from "./ModalHistoryAttachment.vue?vue&type=script&lang=js"
export * from "./ModalHistoryAttachment.vue?vue&type=script&lang=js"
import style0 from "./ModalHistoryAttachment.vue?vue&type=style&index=0&id=63814f91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63814f91",
  null
  
)

export default component.exports